import {
  RETURN_CHANNEL,
  CARRIER_LIST,
  SHIPMENT_STATUS,
  SEARCH_TYPE,
  ORDER_TYPE,
  PLATFORM,
  SHOP,
  STORE,
  PersonalizeService,
  SourceGroup,
  HIDDEN_PLATFORMS
} from '../constants'

import { companies } from '@rhitics/core/config'

export namespace SearchFieldInfo {
  export interface Operator {
    text: string
    value: string
  }
  export interface Column {
    text: string
    type: string // 當此值為'array'(不是型別的array)時，默認為多選
    value: string // 此值為送去後端的key值，如果選項是群組式的，例如shopify:tw(平台＋商店), 則可設為platform:shop, 如此一來程式在準備送去後端的payload時便會自動拆解
    default: boolean // 當default為true時，此欄位的搜尋將被自動排入預設搜尋
    isGroup?: boolean // 當selectOptions存在選項群組時，應將此值設定為true
    selectable?: boolean // 當這個欄位填值的方式為下拉式選單時，應將此值設定為true
    searchable?: boolean // 當這個欄位填值的方式為下拉可搜尋式選單時，應將此值設定為true
    repeatable?: boolean // 當這個欄位是可重複增加的條件時，應將此值設定為true
    selectOptions?: Array<any> // 當這個欄位填值的方式為下拉式選單時，應將可選的選項代入此值
  }
}

export const shipmentStatuses = [
  {
    text: 'general.shipment_status.created',
    value: SHIPMENT_STATUS.CREATED
  },
  {
    text: 'general.shipment_status.pending',
    value: SHIPMENT_STATUS.PENDING
  },
  {
    text: 'general.shipment_status.on_hold',
    value: SHIPMENT_STATUS.ON_HOLD
  },
  {
    text: 'general.shipment_status.to_be_processed',
    value: SHIPMENT_STATUS.TO_BE_PROCESSED
  },
  {
    text: 'general.shipment_status.processing',
    value: SHIPMENT_STATUS.PROCESSING
  },
  {
    text: 'general.shipment_status.finish_processing',
    value: SHIPMENT_STATUS.FINISH_PROCESSING
  },
  {
    text: '已出貨',
    value: SHIPMENT_STATUS.SHIPPED
  },
  {
    text: 'general.shipment_status.shipped_no_tracking',
    value: SHIPMENT_STATUS.SHIPPED_NO_TRACKING
  },
  {
    text: 'general.shipment_status.cancel',
    value: SHIPMENT_STATUS.CANCEL
  },
  // {
  //   text: '隱藏',
  //   value: SHIPMENT_STATUS.HIDDEN
  // },
  {
    text: 'general.shipment_status.factory_pending',
    value: SHIPMENT_STATUS.FACTORY_PENDING
  },
  {
    text: 'general.shipment_status.problem_pending',
    value: SHIPMENT_STATUS.PROBLEM_PENDING
  }
]

export const orderTypes = [
  {
    text: 'general.order_type.b2c',
    value: ORDER_TYPE.B2C
  },
  {
    text: 'general.order_type.b2b',
    value: ORDER_TYPE.B2B
  },
  {
    text: 'general.order_type.sample',
    value: ORDER_TYPE.SAMPLE
  },
  {
    text: 'general.order_type.employee',
    value: ORDER_TYPE.EMPOLYEE
  },
  {
    text: 'general.order_type.store_backorder',
    value: ORDER_TYPE.STORE_BACKORDER
  }
]

export const returnChannels = [
  {
    text: 'general.return_channel.no_return_channel',
    value: RETURN_CHANNEL.NO_RETURN_CHANNEL
  },
  {
    text: 'general.return_channel.seven_eleven',
    value: RETURN_CHANNEL.SEVEN_ELEVEN
  },
  {
    text: 'general.return_channel.family_mart',
    value: RETURN_CHANNEL.FAMILY_MART
  },
  {
    text: 'general.return_channel.heimao',
    value: RETURN_CHANNEL.HEIMAO
  },
  {
    text: 'general.return_channel.wu_ri_warehouse',
    value: RETURN_CHANNEL.WU_RI_WAREHOUSE
  },
  {
    text: 'general.return_channel.uk_warehouse',
    value: RETURN_CHANNEL.UK_WAREHOUSE
  },
  {
    text: 'general.return_channel.chase_us',
    value: RETURN_CHANNEL.CHASE_US
  },
  {
    text: 'general.return_channel.rh_nj',
    value: RETURN_CHANNEL.RH_NJ
  },
  {
    text: 'general.return_channel.rh_wa',
    value: RETURN_CHANNEL.RH_WA
  },
  {
    text: 'general.return_channel.rh_de',
    value: RETURN_CHANNEL.RH_DE
  },
  {
    text: 'general.return_channel.rh_fr',
    value: RETURN_CHANNEL.RH_FR
  },
  {
    text: 'general.return_channel.rh_jp',
    value: RETURN_CHANNEL.RH_JP
  },
  {
    text: 'general.return_channel.linex_jp',
    value: RETURN_CHANNEL.LINEX_JP
  },
  {
    text: 'general.return_channel.b2c_europe',
    value: RETURN_CHANNEL.B2C_EUROPE
  },
  {
    text: 'general.return_channel.kerry_europe',
    value: RETURN_CHANNEL.KERRY_EUROPE
  }
]

export const shopifyB2cCarriers = [
  {
    text: 'general.carrier.seven_eleven',
    value: CARRIER_LIST.SEVEN_ELEVEN
  },
  {
    text: 'general.carrier.family_mart',
    value: CARRIER_LIST.FAMILY_MART
  },
  {
    text: 'general.carrier.taiwan_post',
    value: CARRIER_LIST.TAIWAN_POST
  },
  {
    text: 'general.carrier.heimao',
    value: CARRIER_LIST.HEIMAO
  },
  {
    text: 'general.carrier.fedex',
    value: CARRIER_LIST.FEDEX
  },
  {
    text: 'general.carrier.b2c_europe',
    value: CARRIER_LIST.B2C_EUROPE
  },
  {
    text: 'general.carrier.usps',
    value: CARRIER_LIST.USPS
  },
  {
    text: 'general.carrier.dhl',
    value: CARRIER_LIST.DHL
  },
  {
    text: 'general.carrier.sf_express',
    value: CARRIER_LIST.SF_EXPRESS
  },
  {
    text: 'general.carrier.evolab',
    value: CARRIER_LIST.EVOLAB
  },
  {
    text: 'general.carrier.yamato',
    value: CARRIER_LIST.YAMATO
  },
  {
    text: 'general.carrier.linex',
    value: CARRIER_LIST.LINEX
  },
  {
    text: 'general.carrier.return_helper',
    value: CARRIER_LIST.RETURN_HELPER
  },
  {
    text: 'general.carrier.royal_mail',
    value: CARRIER_LIST.ROYAL_MAIL
  },
  {
    text: 'general.carrier.kerry_europe',
    value: CARRIER_LIST.KERRY_EUROPE
  },
  {
    text: 'general.carrier.chase',
    value: CARRIER_LIST.CHASE
  },
  {
    text: 'general.carrier.rhinoshield',
    value: CARRIER_LIST.RHINOSHIELD
  },
  // B2B 用，先不顯示
  // {
  //   text: '未設定',
  //   value: CARRIER_LIST.UNSET_CARRIER
  // }
]

// B2B物流
export const shopifyB2bCarriers = [
  {
    text: 'general.carrier.kerry_tj',
    value: CARRIER_LIST.KERRY_TJ
  }
]

export const ecCarriers = [
  {
    text: 'general.carrier.taiwan_post',
    value: CARRIER_LIST.TAIWAN_POST
  },
  {
    text: 'general.carrier.heimao',
    value: CARRIER_LIST.HEIMAO
  },
  {
    text: 'general.carrier.sf_express',
    value: CARRIER_LIST.SF_EXPRESS
  },
  {
    text: 'general.carrier.return_helper',
    value: CARRIER_LIST.RETURN_HELPER
  },
  {
    text: 'general.carrier.chase',
    value: CARRIER_LIST.CHASE
  },
  {
    text: 'general.carrier.momo_heimao',
    value: CARRIER_LIST.MOMO_HEIMAO
  },
  {
    text: 'general.carrier.momo_seven',
    value: CARRIER_LIST.MOMO_SEVEN
  },
  {
    text: 'general.carrier.momo_family',
    value: CARRIER_LIST.MOMO_FAMILY
  },
  {
    text: 'general.carrier.linex',
    value: CARRIER_LIST.LINEX
  },
  {
    text: 'general.carrier.pinkoi_linex',
    value: CARRIER_LIST.PINKOI_LINEX
  },
  {
    text: 'general.carrier.shopee_heimao',
    value: CARRIER_LIST.SHOPEE_HEIMAO
  },
  {
    text: 'general.carrier.shopee_seven_eleven',
    value: CARRIER_LIST.SHOPEE_SEVEN_ELEVEN
  },
  {
    text: 'general.carrier.shopee_family_mart',
    value: CARRIER_LIST.SHOPEE_FAMILY_MART
  },
  {
    text: 'general.carrier.shopee_xpress',
    value: CARRIER_LIST.SHOPEE_XPRESS
  },
  {
    text: 'general.carrier.shopee_xpress_tomorrow',
    value: CARRIER_LIST.SHOPEE_XPRESS_TOMORROW
  },
  {
    text: 'general.carrier.shopee_home_delivery',
    value: CARRIER_LIST.SHOPEE_HOME_DELIVERY
  },
  {
    text: 'general.carrier.dcard_seven_eleven',
    value: CARRIER_LIST.DCARD_SEVEN_ELEVEN
  },
  {
    text: 'general.carrier.dcard_family_mart',
    value: CARRIER_LIST.DCARD_FAMILY_MART
  },
  {
    text: 'general.carrier.b2c_europe',
    value: CARRIER_LIST.B2C_EUROPE
  },
  {
    text: 'general.carrier.yamato',
    value: CARRIER_LIST.YAMATO
  },
  {
    text: 'general.carrier.kerry_europe',
    value: CARRIER_LIST.KERRY_EUROPE
  }
]

export const ecCarrierFulfilledReportCarriers = [
  ...ecCarriers
]

export const ecCarrierFulfilledReportFormats = [
  {
    text: 'report_formats.order_based',
    value: 'order-based'
  },
  {
    text: 'report_formats.lineitem_based',
    value: 'lineitem-based'
  }
]

export const orderInfoFormats = [
  {
    text: 'general.order_info_format.seven_eleven',
    value: {
      carrier: CARRIER_LIST.SEVEN_ELEVEN,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.family_mart',
    value: {
      carrier: CARRIER_LIST.FAMILY_MART,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.taiwan_post',
    value: {
      carrier: CARRIER_LIST.TAIWAN_POST,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.heimao',
    value: {
      carrier: CARRIER_LIST.HEIMAO,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.fedex',
    value: {
      carrier: CARRIER_LIST.FEDEX,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.b2c_europe',
    value: {
      carrier: CARRIER_LIST.B2C_EUROPE,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.usps',
    value: {
      carrier: CARRIER_LIST.USPS,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.dhl',
    value: {
      carrier: CARRIER_LIST.DHL,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.sf_express',
    value: {
      carrier: CARRIER_LIST.SF_EXPRESS,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.evolab',
    value: {
      carrier: CARRIER_LIST.EVOLAB,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.yamato',
    value: {
      carrier: CARRIER_LIST.YAMATO,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.linex',
    value: {
      carrier: CARRIER_LIST.LINEX,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.return_helper',
    value: {
      carrier: CARRIER_LIST.RETURN_HELPER,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.chase',
    value: {
      carrier: CARRIER_LIST.CHASE,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.royal_mail',
    value: {
      carrier: CARRIER_LIST.ROYAL_MAIL,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.rhinoshield',
    value: {
      carrier: CARRIER_LIST.RHINOSHIELD,
      reportFormat: 'custom-made-order'
    }
  },
  {
    text: 'general.order_info_format.with_notes_and_tracking_info',
    value: {
      carrier: '',
      reportFormat: 'with-notes-and-tracking-info'
    }
  }
]

export const platforms = [
  {
    text: 'general.platform.pchome',
    value: PLATFORM.PCHOME
  },
  {
    text: 'general.platform.yahoo_official_seller',
    value: PLATFORM.YAHOO_OFFICIAL_SELLER
  },
  {
    text: 'general.platform.pinkoi',
    value: PLATFORM.PINKOI
  },
  {
    text: 'general.platform.momo',
    value: PLATFORM.MOMO
  },
  {
    text: 'general.platform.shopee',
    value: PLATFORM.SHOPEE
  },
  {
    text: 'general.platform.books',
    value: PLATFORM.BOOKS
  },
  {
    text: 'general.platform.costco',
    value: PLATFORM.COSTCO
  },
  {
    text: 'general.platform.rhinoshield',
    value: PLATFORM.RHINOSHIELD
  },
  {
    text: 'general.platform.amazon_fbm',
    value: PLATFORM.AMAZON_FBM
  },
  {
    text: 'general.platform.tiktok_shop',
    value: PLATFORM.TIKTOK_SHOP
  },
  {
    text: 'general.platform.tsmc',
    value: PLATFORM.TSMC
  },
  {
    text: 'general.platform.eslite_online',
    value: PLATFORM.ESLITE_ONLINE
  },
  {
    text: 'general.platform.line_gift',
    value: PLATFORM.LINE_GIFT
  },
  {
    text: 'general.platform.douyin',
    value: PLATFORM.DOUYIN
  },
  {
    text: 'general.platform.tmall',
    value: PLATFORM.TMALL
  }
]

export const orderSource = [
  { text: `search.value_group_header.shopify`, value: PLATFORM.SHOPIFY, disabled: true },
  { text: 'search.value.tw', value: `${PLATFORM.SHOPIFY}:${SHOP.TW}` },
  { text: 'search.value.io', value: `${PLATFORM.SHOPIFY}:${SHOP.IO}` },
  { text: 'search.value.fr', value: `${PLATFORM.SHOPIFY}:${SHOP.FR}` },
  { text: 'search.value.de', value: `${PLATFORM.SHOPIFY}:${SHOP.DE}` },
  { text: 'search.value.eu', value: `${PLATFORM.SHOPIFY}:${SHOP.EU}` },
  { text: 'search.value.jp', value: `${PLATFORM.SHOPIFY}:${SHOP.JP}` },
  { text: 'search.value.es', value: `${PLATFORM.SHOPIFY}:${SHOP.ES}` },
  { text: 'search.value.uk', value: `${PLATFORM.SHOPIFY}:${SHOP.UK}` },
  { text: 'search.value.vn', value: `${PLATFORM.SHOPIFY}:${SHOP.VN}` },
  { text: 'search.value.kr', value: `${PLATFORM.SHOPIFY}:${SHOP.KR}` },
  { text: 'search.value.th', value: `${PLATFORM.SHOPIFY}:${SHOP.TH}` },
  { text: 'search.value.asia', value: `${PLATFORM.SHOPIFY}:${SHOP.ASIA}` },
  { text: 'search.value.b2b_en', value: `${PLATFORM.SHOPIFY}:${SHOP.B2B_EN}` },
  { text: 'search.value.b2b_tw', value: `${PLATFORM.SHOPIFY}:${SHOP.B2B_TW}` },
  { text: 'search.value.b2b_taiwan', value: `${PLATFORM.SHOPIFY}:${SHOP.B2B_TAIWAN}` }
]

export const stores = [
  { text: `search.value.b2b_en`, value: STORE.SHOPIFY_B2B_EN },
  { text: `search.value.b2b_tw`, value: STORE.SHOPIFY_B2B_TW },
  { text: `search.value.b2b_taiwan`, value: STORE.SHOPIFY_B2B_TAIWAN },
  { text: `search.value.tw`, value: STORE.SHOPIFY_TW },
  { text: `search.value.fr`, value: STORE.SHOPIFY_FR },
  { text: `search.value.de`, value: STORE.SHOPIFY_DE },
  { text: `search.value.io`, value: STORE.SHOPIFY_IO },
  { text: `search.value.es`, value: STORE.SHOPIFY_ES },
  { text: `search.value.jp`, value: STORE.SHOPIFY_JP },
  { text: `search.value.eu`, value: STORE.SHOPIFY_EU },
  { text: `search.value.uk`, value: STORE.SHOPIFY_UK },
  { text: `search.value.vn`, value: STORE.SHOPIFY_VN },
  { text: `search.value.kr`, value: STORE.SHOPIFY_KR },
  { text: `search.value.th`, value: STORE.SHOPIFY_TH },
  { text: `search.value.asia`, value: STORE.SHOPIFY_ASIA },
  { text: `search.value.kroma`, value: STORE.SHOPIFY_KROMA },
  { text: `search.value.kroma_tw`, value: STORE.SHOPIFY_KROMA_TW },
  { text: `search.value.kroma_fr`, value: STORE.SHOPIFY_KROMA_FR }
]

export const ecStores = [
  { text: `general.store.pchome_tw`, value: STORE.PCHOME_TW },
  { text: `general.store.yahoo_official_seller_tw`, value: STORE.YAHOO_OFFICIAL_SELLER_TW },
  { text: `general.store.pinkoi_tw`, value: STORE.PINKOI_TW },
  { text: `general.store.momo_tw`, value: STORE.MOMO_TW },
  { text: `general.store.shopee_tw`, value: STORE.SHOPEE_TW },
  { text: `general.store.books_tw`, value: STORE.BOOKS_TW },
  { text: `general.store.costco_tw`, value: STORE.COSTCO_TW },
  { text: `general.store.amazon_fbm_us`, value: STORE.AMAZON_FBM_US },
  { text: `general.store.amazon_fbm_fr`, value: STORE.AMAZON_FBM_FR },
  { text: `general.store.amazon_fbm_de`, value: STORE.AMAZON_FBM_DE },
  { text: `general.store.amazon_fbm_jp`, value: STORE.AMAZON_FBM_JP },
  { text: `general.store.tiktok_shop_cn`, value: STORE.TIKTOK_SHOP_CN },
  { text: `general.store.tiktok_shop_fr`, value: STORE.TIKTOK_SHOP_FR },
  { text: `general.store.eslite_online_tw`, value: STORE.ESLITE_ONLINE_TW }
]

export const sourceGroup = [
  { text: `general.sourceGroup.shopify_b2b`, value: SourceGroup.SHOPIFY_B2B },
  { text: `general.sourceGroup.shopify_b2c`, value: SourceGroup.SHOPIFY_B2C },
  { text: `general.sourceGroup.ec`, value: SourceGroup.EC },
  { text: `general.sourceGroup.consignment`, value: SourceGroup.CONSIGNMENT },
  { text: `general.sourceGroup.b2bio`, value: SourceGroup.B2BIO }
]

export const orderFeature = [
  { text: 'general.custom_type.custom', value: true },
  { text: 'general.custom_type.common', value: false }
]

export const factoryStatuses = [
  { text: 'general.factory_status.all', value: '*' },
  { text: 'general.factory_status.no_sku', value: 'no_sku' },
  { text: 'general.factory_status.end_of_life', value: 'end_of_life' },
  { text: 'general.factory_status.missing_leash_data', value: 'missing_leash_data' },
  { text: 'general.factory_status.no_stock', value: 'no_stock' },
  { text: 'general.factory_status.no_printer', value: 'no_printer' },
  { text: 'general.factory_status.no_pickup_car', value: 'no_pickup_car' },
  { text: 'general.factory_status.no_pack_station', value: 'no_pack_station' },
  { text: 'general.factory_status.pending', value: 'pending' },
  { text: 'general.factory_status.preorder', value: 'preorder' },
  { text: 'general.factory_status.allocated', value: 'allocated' },
  { text: 'general.factory_status.print_allocated', value: 'print_allocated' },
  { text: 'general.factory_status.print_pending', value: 'print_pending' },
  { text: 'general.factory_status.printing', value: 'printing' },
  { text: 'general.factory_status.print_bumper_assembling', value: 'print_bumper_assembling' },
  { text: 'general.factory_status.print_match', value: 'print_match' },
  { text: 'general.factory_status.print_packed', value: 'print_packed' },
  { text: 'general.factory_status.print_packing', value: 'print_packing' },
  { text: 'general.factory_status.print_pasting', value: 'print_pasting' },
  { text: 'general.factory_status.waiting_label', value: 'waiting_label' },
  { text: 'general.factory_status.received_label', value: 'received_label' },
  { text: 'general.factory_status.printed', value: 'printed' },
  { text: 'general.factory_status.picking', value: 'picking' },
  { text: 'general.factory_status.picked', value: 'picked' },
  { text: 'general.factory_status.packing', value: 'packing' },
  { text: 'general.factory_status.packed', value: 'packed' },
  { text: 'general.factory_status.fulfilled', value: 'fulfilled' },
  { text: 'general.factory_status.canceled', value: 'canceled' },
  { text: 'general.factory_status.paused', value: 'paused' },
  { text: 'general.factory_status.box_allocate_error', value: 'box_allocate_error' },
  { text: 'general.factory_status.no_bom', value: 'no_bom' }
]

export const generalSearchFieldInfo: {
  operator: {
    [name: string]: Array<SearchFieldInfo.Operator>
  }
  column: {
    [name: string]: Array<SearchFieldInfo.Column>
  }
} = {
  operator: {
    string: [
      { text: 'equal', value: '=' },
      { text: 'not_equal', value: '!=' }
    ],
    number: [
      { text: '=', value: '=' },
      { text: '>', value: '>' },
      { text: '<', value: '<' },
      { text: '>=', value: '>=' },
      { text: '<=', value: '<=' }
    ],
    array: [
      { text: 'include', value: 'in' },
      { text: 'exclude', value: 'not in' }
    ],
    boolean: [{ text: 'equal', value: '=' }],
    dateTime: [
      { text: '>', value: '>' },
      { text: '<', value: '<' },
      { text: '>=', value: '>=' },
      { text: '<=', value: '<=' }
    ],
    text: [
      { text: 'like', value: 'like' }
    ]
  },
  column: {
    [SEARCH_TYPE.SHIPMENT_SEARCH]: [
      {
        text: 'carrier',
        value: 'carrier',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shopifyB2cCarriers
      },
      {
        text: 'status',
        value: 'status',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shipmentStatuses
      },
      {
        text: 'order_type',
        value: 'orderType',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: orderTypes
      },
      {
        text: 'order_feature',
        value: 'isCustomMade',
        type: 'boolean',
        default: false,
        selectable: true,
        selectOptions: orderFeature
      }
    ],
    [SEARCH_TYPE.ORDER_SEARCH]: [
      {
        text: 'carrier',
        value: 'shippingLines.carrier',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shopifyB2cCarriers
      },
      {
        text: 'status',
        value: 'shipments.status',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shipmentStatuses
      },
      {
        text: 'order_type',
        value: 'orderType',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: orderTypes
      },
      {
        text: 'order_source',
        value: 'platform:shop',
        type: 'string',
        default: false,
        isGroup: true,
        selectable: true,
        searchable: true,
        selectOptions: orderSource
      },
      {
        text: 'origin_created_at',
        value: 'originCreatedAt',
        type: 'dateTime',
        default: false,
        searchable: true
      },
      {
        text: 'order_feature',
        value: 'shipments.isCustomMade',
        type: 'boolean',
        default: false,
        selectable: true,
        selectOptions: orderFeature
      },
      {
        text: 'order_company',
        value: 'company',
        type: 'string',
        default: false,
        selectable: true,
        selectOptions: companies
      }
    ],
    [SEARCH_TYPE.OUTERBOX_SEARCH]: [
      {
        text: 'shipment_carrier',
        value: 'shipmentCarriers',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shopifyB2cCarriers
      },
      {
        text: 'shipped_at',
        value: 'shippedAt',
        type: 'dateTime',
        default: false,
        repeatable: true,
        searchable: true
      },
      {
        text: 'arrived_at',
        value: 'arrivedAt',
        type: 'dateTime',
        default: false,
        repeatable: true,
        searchable: true
      }
    ]
  }
}

export const shopifyB2cSearchFieldInfo: {
  operator: {
    [name: string]: Array<SearchFieldInfo.Operator>
  }
  column: {
    [name: string]: Array<SearchFieldInfo.Column>
  }
} = {
  operator: {
    string: [
      { text: 'equal', value: '=' },
      { text: 'not_equal', value: '!=' }
    ],
    number: [
      { text: '=', value: '=' },
      { text: '>', value: '>' },
      { text: '<', value: '<' },
      { text: '>=', value: '>=' },
      { text: '<=', value: '<=' }
    ],
    array: [
      { text: 'include', value: 'in' },
      { text: 'exclude', value: 'not in' }
    ],
    boolean: [{ text: 'equal', value: '=' }],
    dateTime: [
      { text: '>', value: '>' },
      { text: '<', value: '<' },
      { text: '>=', value: '>=' },
      { text: '<=', value: '<=' }
    ],
    text: [
      { text: 'like', value: 'like' }
    ]
  },
  column: {
    [SEARCH_TYPE.SHOPIFY_B2C_SHIPMENT_SEARCH]: [
      {
        text: 'carrier',
        value: 'carrier',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shopifyB2cCarriers
      },
      {
        text: 'status',
        value: 'status',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shipmentStatuses
      },
      {
        text: 'order_type',
        value: 'orderType',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: orderTypes
      },
      {
        text: 'order_feature',
        value: 'isCustomMade',
        type: 'boolean',
        default: false,
        selectable: true,
        selectOptions: orderFeature
      }
    ],
    [SEARCH_TYPE.SHOPIFY_B2C_ORDER_SEARCH]: [
      {
        text: 'carrier',
        value: 'shippingLines.carrier',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shopifyB2cCarriers
      },
      {
        text: 'status',
        value: 'shipments.status',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shipmentStatuses
      },
      {
        text: 'order_type',
        value: 'orderType',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: orderTypes
      },
      {
        text: 'order_source',
        value: 'platform:shop',
        type: 'string',
        default: false,
        isGroup: true,
        selectable: true,
        searchable: true,
        selectOptions: orderSource
      },
      {
        text: 'origin_created_at',
        value: 'originCreatedAt',
        type: 'dateTime',
        default: false,
        searchable: true
      },
      {
        text: 'order_feature',
        value: 'shipments.isCustomMade',
        type: 'boolean',
        default: false,
        selectable: true,
        selectOptions: orderFeature
      },
      {
        text: 'order_company',
        value: 'company',
        type: 'string',
        default: false,
        selectable: true,
        selectOptions: companies
      }
      // {
      //   text: 'line_item.sku',
      //   value: 'lineItems.sku',
      //   type: 'text',
      //   default: false,
      // }
    ],
    [SEARCH_TYPE.SHOPIFY_B2C_OUTERBOX_SEARCH]: [
      {
        text: 'shipment_carrier',
        value: 'shipmentCarriers',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shopifyB2cCarriers
      },
      {
        text: 'shipped_at',
        value: 'shippedAt',
        type: 'dateTime',
        default: false,
        repeatable: true,
        searchable: true
      },
      {
        text: 'arrived_at',
        value: 'arrivedAt',
        type: 'dateTime',
        default: false,
        repeatable: true,
        searchable: true
      }
    ]
  }
}

export const ecSearchFieldInfo: {
  operator: {
    [name: string]: Array<SearchFieldInfo.Operator>
  }
  column: {
    [name: string]: Array<SearchFieldInfo.Column>
  }
} = {
  operator: {
    string: [
      { text: 'equal', value: '=' },
      { text: 'not_equal', value: '!=' }
      // { text: 'include', value: 'like' },
      // { text: 'exclude', value: 'not like' }
    ],
    number: [
      { text: '=', value: '=' },
      { text: '>', value: '>' },
      { text: '<', value: '<' },
      { text: '>=', value: '>=' },
      { text: '<=', value: '<=' }
    ],
    dateTime: [
      { text: '>', value: '>' },
      { text: '<', value: '<' },
      { text: '>=', value: '>=' },
      { text: '<=', value: '<=' }
    ],
    date: [
      { text: '>', value: '>' },
      { text: '<', value: '<' },
      { text: '>=', value: '>=' },
      { text: '<=', value: '<=' },
      { text: '=', value: '=' },
    ],
    array: [
      { text: 'include', value: 'in' },
      { text: 'exclude', value: 'not in' }
    ],
    boolean: [{ text: 'equal', value: '=' }]
  },
  column: {
    [SEARCH_TYPE.EC_ORDER_SEARCH]: [
      {
        text: 'platform',
        value: 'platform',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: platforms.filter(platform => !HIDDEN_PLATFORMS.includes(platform.value))
      },
      {
        text: 'origin_created_at',
        value: 'orderCreatedAt',
        type: 'date',
        default: false,
        searchable: true
      },
      {
        text: 'imported_at',
        value: 'importedAt',
        type: 'date',
        default: false,
        searchable: true
      },
      {
        text: 'order_feature',
        value: 'isCustomMade',
        type: 'boolean',
        default: false,
        selectable: true,
        selectOptions: orderFeature
      },
    ],
    [SEARCH_TYPE.EC_SHIPMENT_SEARCH]: [
      {
        text: 'platform',
        value: 'platform',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: platforms.filter(platform => !HIDDEN_PLATFORMS.includes(platform.value))
      },
      {
        text: 'carrier',
        value: 'carrier',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: ecCarriers
      },
      {
        text: 'status',
        value: 'status',
        type: 'array',
        default: false,
        selectable: true,
        selectOptions: shipmentStatuses
      },
      {
        text: 'origin_created_at',
        value: 'orders.originCreatedAt',
        type: 'date',
        default: false,
        searchable: true
      },
      {
        text: 'omc_order_created_at',
        value: 'orders.createdAt',
        type: 'date',
        default: false,
        searchable: true
      },
      {
        text: 'order_feature',
        value: 'isCustomMade',
        type: 'boolean',
        default: false,
        selectable: true,
        selectOptions: orderFeature
      },
      {
        text: 'packed_at',
        value: 'packedAt',
        type: 'date',
        default: false,
        searchable: true
      },
      {
        text: 'shipped_at',
        value: 'shippedAt',
        type: 'date',
        default: false,
        searchable: true
      },
    ]
  }
}

export const customMadeOptions = [
  {
    text: 'general.custom_type.common',
    value: 'common'
  },
  {
    text: 'general.custom_type.custom',
    value: 'custom'
  }
]
